<template>
  <ul class="space-y-12">
    <CallsAndSmsUnlimitedTowardsFrance
      v-if="benefits.includes('CALLS_AND_SMS_UNLIMITED_TOWARDS_FRANCE')"
      :with5g="false"
    />

    <CallsAndSmsUnlimitedTowardsFrance
      v-if="benefits.includes('CALLS_AND_SMS_UNLIMITED_TOWARDS_FRANCE_5G')"
      with5g
    />

    <CallsAndSmsUnlimitedTowardsEurope120Contries
      v-if="
        benefits.includes('CALLS_UNLIMITED_FROM_FRANCE_TOWARDS_120_COUNTRIES')
      "
    />

    <Plan90goFrance25goEurope
      v-if="benefits.includes('PLAN_90GO_FRANCE_25GO_EUROPE')"
    />

    <Plan150goFrance30goEurope
      v-if="benefits.includes('PLAN_150GO_FRANCE_30GO_EUROPE')"
    />

    <Plan300goFrance35goEurope
      v-if="benefits.includes('PLAN_150GO_FRANCE_35GO_EUROPE')"
    />

    <Plan150goFrance30goInternational10Countries
      v-if="
        benefits.includes('PLAN_150GO_FRANCE_30GO_INTERNATIONAL_10_COUNTRIES')
      "
    />

    <Plan200goFrance35goInternational15Countries
      v-if="
        benefits.includes('PLAN_200GO_FRANCE_35GO_INTERNATIONAL_15_COUNTRIES')
      "
    />

    <LoanMobilephone v-if="benefits.includes('LOAN_MOBILEPHONE')" />

    <Discount30PercentWefix
      v-if="benefits.includes('DISCOUNT_30_PERCENT_WEFIX')"
    />

    <SecondSim v-if="benefits.includes('SECOND_SIM')" />

    <Norton24Months v-if="benefits.includes('NORTON_24_MONTHS')" />

    <NetworkQuality v-if="benefits.includes('NETWORK_QUALITY')" />

    <ParentalOption v-if="benefits.includes('PARENTAL_OPTION')" />
  </ul>
</template>

<script setup lang="ts">
import type { Benefit } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import CallsAndSmsUnlimitedTowardsEurope120Contries from './components/CallsAndSmsUnlimitedTowardsEurope120Contries/CallsAndSmsUnlimitedTowardsEurope120Contries.vue'
import CallsAndSmsUnlimitedTowardsFrance from './components/CallsAndSmsUnlimitedTowardsFrance/CallsAndSmsUnlimitedTowardsFrance.vue'
import Discount30PercentWefix from './components/Discount30PercentWefix/Discount30PercentWefix.vue'
import LoanMobilephone from './components/LoanMobilephone/LoanMobilephone.vue'
import NetworkQuality from './components/NetworkQuality/NetworkQuality.vue'
import Norton24Months from './components/Norton24Months/Norton24Months.vue'
import ParentalOption from './components/ParentalOption/ParentalOption.vue'
import Plan150goFrance30goEurope from './components/Plan150goFrance30goEurope/Plan150goFrance30goEurope.vue'
import Plan150goFrance30goInternational10Countries from './components/Plan150goFrance30goInternational10Countries/Plan150goFrance30goInternational10Countries.vue'
import Plan200goFrance35goInternational15Countries from './components/Plan200goFrance35goInternational15Countries/Plan200goFrance35goInternational15Countries.vue'
import Plan300goFrance35goEurope from './components/Plan300goFrance35goEurope/Plan300goFrance35goEurope.vue'
import Plan90goFrance25goEurope from './components/Plan90goFrance25goEurope/Plan90goFrance25goEurope.vue'
import SecondSim from './components/SecondSim/SecondSim.vue'

defineProps<{
  benefits: Benefit[] | Readonly<Benefit[]>
}>()
</script>
